var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUsersGroup = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 7.00001C12.3327 8.28867 11.288 9.33334 9.99935 9.33334C8.71068 9.33334 7.66602 8.28867 7.66602 7.00001C7.66602 5.71134 8.71068 4.66667 9.99935 4.66667C11.288 4.66667 12.3327 5.71134 12.3327 7.00001Z",
    fill: "#F6932B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13C14 14.2887 12.2091 15.3333 10 15.3333C7.79086 15.3333 6 14.2887 6 13C6 11.7113 7.79086 10.6667 10 10.6667C12.2091 10.6667 14 11.7113 14 13Z",
    fill: "#F6932B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74868 5.33333C6.86699 5.33333 6.98249 5.34494 7.09402 5.36704C6.82231 5.84963 6.66732 6.40671 6.66732 6.99999C6.66732 7.57883 6.81486 8.12321 7.07438 8.59757C6.96895 8.61721 6.86006 8.6275 6.74868 8.6275C5.80574 8.6275 5.04133 7.89008 5.04133 6.98042C5.04133 6.07075 5.80574 5.33333 6.74868 5.33333Z",
    fill: "#F6932B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63221 14.6573C5.2536 14.2047 5.00065 13.6493 5.00065 13C5.00065 12.3705 5.23837 11.8293 5.59784 11.3845C4.32805 11.483 3.33398 12.1775 3.33398 13.0196C3.33398 13.8696 4.34552 14.5692 5.63221 14.6573Z",
    fill: "#F6932B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 6.99999C13.333 7.57883 13.1854 8.12321 12.9259 8.59757C13.0313 8.61722 13.1402 8.6275 13.2516 8.6275C14.1945 8.6275 14.9589 7.89008 14.9589 6.98042C14.9589 6.07075 14.1945 5.33333 13.2516 5.33333C13.1333 5.33333 13.0178 5.34494 12.9062 5.36704C13.178 5.84963 13.333 6.40671 13.333 6.99999Z",
    fill: "#F6932B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3681 14.6573C15.6548 14.5692 16.6663 13.8696 16.6663 13.0196C16.6663 12.1775 15.6722 11.483 14.4024 11.3845C14.7619 11.8293 14.9996 12.3705 14.9996 13C14.9996 13.6493 14.7467 14.2047 14.3681 14.6573Z",
    fill: "#F6932B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsersGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UsersGroup.68619e31.svg";
export { ForwardRef as ReactComponent };